import { useMutation, useQuery } from '@tanstack/react-query';
import { groupsOrganizationService } from '../services/groups-organization.service';
import { AddOrganizationsToGroupRequest } from '../types/dtos/organization/groups-organization';
import { useOrganization } from '../../contexts/OrganizationContext';

export const useAddOrganizationsToGroup = () => {
  const { selectedOrganization } = useOrganization();
  return useMutation({
    mutationFn: ({
      groupId,
      organizationIds,
    }: {
      groupId: string;
      organizationIds: AddOrganizationsToGroupRequest;
    }) =>
      groupsOrganizationService.addOrganizationsToGroup(
        selectedOrganization?.id || '',
        groupId,
        organizationIds
      ),
  });
};

export const useGroupsByOrganizationId = (orgId: string) => {
  return useQuery({
    queryKey: ['groups-organization', orgId],
    queryFn: () => groupsOrganizationService.getGroupsByOrganizationId(orgId),
    enabled: !!orgId
  });
};

/**
 * Hook to fetch all organizations that belong to a specific group
 */
export const useGroupOrganizations = (
  organizationId: string,
  groupId: string,
  params?: { isActive?: boolean }
) => {
  return useQuery({
    queryKey: ['group-organizations', organizationId, groupId, params],
    queryFn: async () => {
      const response = await groupsOrganizationService.getGroupOrganizations(
        organizationId,
        groupId,
        params
      );
      // Extract the organization IDs from the response
      return response.data || [];
    },
    enabled: !!organizationId && !!groupId,
  });
};

export const useDeleteGroupRelation = () => {
  return useMutation({
    mutationFn: ({
      organizationId,
      groupId,
      groupOrganizationId,
    }: {
      organizationId: string;
      groupId: string;
      groupOrganizationId: string;
    }) =>
      groupsOrganizationService.deleteGroupRelation(
        organizationId,
        groupId,
        groupOrganizationId
      ),
  });
}; 